import { getRuntimeConfig } from './runtime-config'

/**
 * Application Insights telemetry configuration for the Vue 3 SPA.
 *
 * The SPA reports to a dedicated App Insights resource (separate from the Vue 2
 * shell). The connection string comes from the backend at runtime — the same
 * `appsettings.{env}.json` value the Razor layouts inject into V2 — so a single
 * build artifact reports to the right resource in every environment. When unset
 * (local dev / tests) telemetry is a no-op; see
 * `infrastructure/analytics/app-insights.ts`.
 *
 * An accessor, not a plain value: `initTelemetry` runs after `loadRuntimeConfig()`
 * resolves, so the read must happen at access time rather than at module load.
 */
export const TELEMETRY_CONFIG = {
  get connectionString(): string {
    return getRuntimeConfig().appInsightsConnectionString
  },
}
